<aside
  class="sidebar fixed flex flex-col top-0 left-0 bg-white dark:bg-gray-950 text-gray-900 dark:text-gray-300 h-screen transition-all duration-300 ease-in-out z-50 border-r border-gray-200 dark:border-gray-800"
  [class.sidebar--compact]="ui.mode() === 'compact'"
  [class.sidebar--collapsed]="ui.mode() === 'collapsed'"
  [class.sidebar--overlay]="ui.overlay()"
  [ngClass]="{
    'w-[290px]': showLabels(),
    'w-16': !showLabels(),
    'translate-x-0': !ui.overlay() || (isMobileOpen$ | async),
    '-translate-x-full': ui.overlay() && !(isMobileOpen$ | async)
  }"
  (mouseenter)="onSidebarMouseEnter()"
  (mouseleave)="sidebarService.setHovered(false)"
  role="navigation"
  [attr.aria-label]="'Menú principal'">
  <div class="sidebar__header py-4 flex items-center transition-all duration-300 flex-shrink-0" [ngClass]="{
    'justify-center px-0': !showLabels(),
    'justify-start px-4': showLabels()
  }">
    <a routerLink="/" class="w-10 h-10 rounded-lg bg-brand-500 flex items-center justify-center hover:bg-brand-600 transition-colors flex-shrink-0" aria-label="Ir al inicio">
      <svg class="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
        <circle cx="12" cy="12" r="3" fill="currentColor" />
        <circle cx="12" cy="12" r="8" stroke="currentColor" stroke-width="2" fill="none" />
        <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1" fill="none" opacity="0.5" />
      </svg>
    </a>
    @if (showLabels()) {
      <div class="ml-3 flex flex-col min-w-0">
        <span class="text-gray-900 dark:text-white font-semibold text-sm sidebar__nav-title">LT10</span>
        <span class="text-gray-600 dark:text-gray-400 text-xs sidebar__nav-subtitle">Órdenes de Publicidad</span>
      </div>
    }
  </div>

  <nav class="sidebar__menu flex flex-col gap-1 px-2 flex-1 min-h-0 overflow-y-auto" aria-label="Navegación">
    @for (item of filteredMenuItems; track item.name) {
      @if (item.subItems && item.subItems.length > 0) {
        <div>
          <a
            (click)="toggleSubmenu(item.name, $event)"
            [routerLink]="item.path"
            routerLinkActive="bg-gray-100 dark:bg-gray-800 text-brand-500"
            [routerLinkActiveOptions]="{exact: false}"
            class="sidebar__nav-item rounded-lg flex items-center transition-all duration-200 group relative overflow-hidden cursor-pointer min-h-[38px]"
            [attr.title]="!showLabels() ? item.name : null"
            [attr.aria-label]="item.name"
            [attr.aria-expanded]="showLabels() ? isSubmenuOpen(item.name) : null"
            [ngClass]="{
              'px-2 py-2 justify-center w-10 mx-auto': !showLabels(),
              'px-3 py-3 justify-start w-full hover:bg-gray-100 dark:hover:bg-gray-800': showLabels(),
              'bg-gray-100 dark:bg-gray-800 text-brand-500': isActive(item.path || ''),
              'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white': !isActive(item.path || '')
            }">
            <span class="sidebar__icon-wrap sidebar__icon-wrap--lg flex-shrink-0 w-5 h-5 flex items-center justify-center" [innerHTML]="item.icon | safeHtml"></span>
            @if (showLabels()) {
              <div class="ml-3 flex-1 text-left min-w-0">
                <div class="font-medium text-sm sidebar__nav-title">{{ item.name }}</div>
                @if (item.description && ui.mode() !== 'compact') {
                  <div class="text-xs text-gray-500 dark:text-gray-500 mt-0.5 sidebar__nav-subtitle">{{ item.description }}</div>
                }
              </div>
              <svg class="w-4 h-4 flex-shrink-0 transition-transform duration-200" [class.rotate-180]="isSubmenuOpen(item.name)" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
              </svg>
            }
          </a>
          @if (showLabels()) {
            <div class="overflow-hidden transition-all duration-300 ease-in-out" [ngClass]="{
              'max-h-0': !isSubmenuOpen(item.name),
              'max-h-96': isSubmenuOpen(item.name)
            }">
              <div class="ml-4 pl-4 border-l border-gray-300 dark:border-gray-700 space-y-1 py-1">
                @for (subItem of item.subItems; track subItem.path) {
                  <a
                    [routerLink]="subItem.path"
                    (click)="ui.overlay() && closeDrawer()"
                    routerLinkActive="text-brand-500"
                    [routerLinkActiveOptions]="{exact: true}"
                    class="sidebar__nav-item-sub flex items-center gap-2 px-3 py-2 rounded-md text-sm transition-colors duration-200 min-h-[36px]"
                    [ngClass]="{
                      'text-brand-500 bg-gray-100/50 dark:bg-gray-800/50': isActive(subItem.path),
                      'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white hover:bg-gray-100/30 dark:hover:bg-gray-800/30': !isActive(subItem.path)
                    }">
                    @if (subItem.icon) {
                      <span class="sidebar__icon-wrap flex-shrink-0 w-4 h-4 flex items-center justify-center" [innerHTML]="subItem.icon | safeHtml"></span>
                    }
                    <span>{{ subItem.name }}</span>
                  </a>
                }
              </div>
            </div>
          }
        </div>
      } @else {
        <a
          [routerLink]="item.path"
          (click)="ui.overlay() && closeDrawer()"
          routerLinkActive="bg-gray-100 dark:bg-gray-800 text-brand-500"
          [routerLinkActiveOptions]="{exact: item.path === '/'}"
          class="sidebar__nav-item rounded-lg flex items-center transition-all duration-200 group relative overflow-hidden min-h-[38px]"
          [attr.title]="!showLabels() ? item.name : null"
          [attr.aria-label]="item.name"
          [ngClass]="{
            'px-2 py-2 justify-center w-10 mx-auto': !showLabels(),
            'px-3 py-3 justify-start w-full hover:bg-gray-100 dark:hover:bg-gray-800': showLabels(),
            'bg-gray-100 dark:bg-gray-800 text-brand-500': isActive(item.path || ''),
            'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white': !isActive(item.path || '')
          }">
          <span class="sidebar__icon-wrap sidebar__icon-wrap--lg flex-shrink-0 w-5 h-5 flex items-center justify-center" [innerHTML]="item.icon | safeHtml"></span>
          @if (showLabels()) {
            <div class="ml-3 flex-1 text-left min-w-0">
              <div class="font-medium text-sm sidebar__nav-title">{{ item.name }}</div>
              @if (item.description && ui.mode() !== 'compact') {
                <div class="text-xs text-gray-500 dark:text-gray-500 mt-0.5 sidebar__nav-subtitle">{{ item.description }}</div>
              }
            </div>
          }
        </a>
      }
    }
  </nav>

  <div class="sidebar__footer flex flex-col gap-1 px-2 pb-4 flex-shrink-0">
    @if (ui.mode() === 'collapsed' && !showLabels()) {
      <button
        type="button"
        (click)="toggleRailExpand()"
        class="rounded-lg flex items-center justify-center w-10 h-10 mx-auto text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white hover:bg-gray-100 dark:hover:bg-gray-800 transition-all duration-200"
        [attr.aria-label]="'Expandir menú'"
        title="Expandir menú">
        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 5l7 7-7 7M5 5l7 7-7 7" />
        </svg>
      </button>
    }
    <button
      type="button"
      (click)="themeService.toggleTheme()"
      class="rounded-lg flex items-center transition-all duration-200 group relative overflow-hidden text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white min-h-[38px]"
      [ngClass]="{
        'px-2 py-2 justify-center w-10 mx-auto': !showLabels(),
        'px-3 py-3 justify-start w-full hover:bg-gray-100 dark:hover:bg-gray-800': showLabels()
      }"
      [attr.title]="(themeService.theme$ | async) === 'dark' ? 'Cambiar a modo claro' : 'Cambiar a modo oscuro'"
      [attr.aria-label]="(themeService.theme$ | async) === 'dark' ? 'Cambiar a modo claro' : 'Cambiar a modo oscuro'">
      @if ((themeService.theme$ | async) === 'dark') {
        <svg class="w-5 h-5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z" />
        </svg>
      } @else {
        <svg class="w-5 h-5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z" />
        </svg>
      }
      @if (showLabels()) {
        <span class="ml-3 text-sm font-medium">Tema</span>
      }
    </button>

    <div class="relative">
      <button
        type="button"
        (click)="toggleUserMenu()"
        class="rounded-lg flex items-center transition-all duration-200 group relative overflow-hidden w-full text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white hover:bg-gray-100 dark:hover:bg-gray-800 min-h-[38px]"
        [ngClass]="{
          'px-2 py-2 justify-center w-10 mx-auto': !showLabels(),
          'px-3 py-3 justify-start': showLabels()
        }"
        [attr.aria-label]="'Menú de usuario'"
        [attr.aria-expanded]="isUserMenuOpen"
        title="{{ showLabels() ? '' : getNombreCorto() }}">
        <span class="overflow-hidden rounded-full h-9 w-9 flex-shrink-0">
          <img [src]="avatarUrl | authImage | async" [alt]="getNombreCompleto()" class="w-full h-full object-cover" />
        </span>
        @if (showLabels()) {
          <div class="ml-3 flex-1 text-left min-w-0">
            <div class="font-medium text-sm text-gray-900 dark:text-white truncate sidebar__nav-title">{{ getNombreCorto() }}</div>
            <div class="text-xs text-gray-500 dark:text-gray-500 truncate sidebar__nav-subtitle">{{ usuario.email || 'Sin email' }}</div>
          </div>
          <svg class="w-4 h-4 flex-shrink-0 transition-transform duration-200" [class.rotate-180]="isUserMenuOpen" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
          </svg>
        }
      </button>

      @if (isUserMenuOpen && showLabels()) {
        <div class="absolute bottom-full left-0 mb-2 w-full rounded-lg border border-gray-300 dark:border-gray-700 bg-white dark:bg-gray-800 shadow-lg z-50">
          @if (usuario && usuario.id) {
            <div class="p-2 border-b border-gray-300 dark:border-gray-700">
              <a routerLink="/profile" (click)="closeUserMenu(); ui.overlay() && closeDrawer()" class="flex items-center gap-3 w-full px-3 py-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 text-gray-700 dark:text-gray-300 text-sm">
                <svg class="fill-gray-600 dark:fill-gray-400" width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 14.1526 4.3002 16.1184 5.61936 17.616C6.17279 15.3096 8.24852 13.5955 10.7246 13.5955H13.2746C15.7509 13.5955 17.8268 15.31 18.38 17.6167C19.6996 16.119 20.5 14.153 20.5 12C20.5 7.30558 16.6944 3.5 12 3.5ZM17.0246 18.8566V18.8455C17.0246 16.7744 15.3457 15.0955 13.2746 15.0955H10.7246C8.65354 15.0955 6.97461 16.7744 6.97461 18.8455V18.856C8.38223 19.8895 10.1198 20.5 12 20.5C13.8798 20.5 15.6171 19.8898 17.0246 18.8566ZM2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM11.9991 7.25C10.8847 7.25 9.98126 8.15342 9.98126 9.26784C9.98126 10.3823 10.8847 11.2857 11.9991 11.2857C13.1135 11.2857 14.0169 10.3823 14.0169 9.26784C14.0169 8.15342 13.1135 7.25 11.9991 7.25ZM8.48126 9.26784C8.48126 7.32499 10.0563 5.75 11.9991 5.75C13.9419 5.75 15.5169 7.32499 15.5169 9.26784C15.5169 11.2107 13.9419 12.7857 11.9991 12.7857C10.0563 12.7857 8.48126 11.2107 8.48126 9.26784Z" fill="" />
                </svg>
                Perfil
              </a>
            </div>
          }
          <div class="p-2">
            <button type="button" (click)="logout()" class="flex items-center w-full gap-3 px-3 py-2 rounded-lg hover:bg-red-100 dark:hover:bg-red-900/20 text-red-600 dark:text-red-400 text-sm font-medium">
              <svg class="fill-current" width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M15.1007 19.247C14.6865 19.247 14.3507 18.9112 14.3507 18.497L14.3507 14.245H12.8507V18.497C12.8507 19.7396 13.8581 20.747 15.1007 20.747H18.5007C19.7434 20.747 20.7507 19.7396 20.7507 18.497L20.7507 5.49609C20.7507 4.25345 19.7433 3.24609 18.5007 3.24609H15.1007C13.8581 3.24609 12.8507 4.25345 12.8507 5.49609V9.74501L14.3507 9.74501V5.49609C14.3507 5.08188 14.6865 4.74609 15.1007 4.74609L18.5007 4.74609C18.9149 4.74609 19.2507 5.08188 19.2507 5.49609L19.2507 18.497C19.2507 18.9112 18.9149 19.247 18.5007 19.247H15.1007ZM3.25073 11.9984C3.25073 12.2144 3.34204 12.4091 3.48817 12.546L8.09483 17.1556C8.38763 17.4485 8.86251 17.4487 9.15549 17.1559C9.44848 16.8631 9.44863 16.3882 9.15583 16.0952L5.81116 12.7484L16.0007 12.7484C16.4149 12.7484 16.7507 12.4127 16.7507 11.9984C16.7507 11.5842 16.4149 11.2484 16.0007 11.2484L5.81528 11.2484L9.15585 7.90554C9.44864 7.61255 9.44847 7.13767 9.15547 6.84488C8.86248 6.55209 8.3876 6.55226 8.09481 6.84525L3.52309 11.4202C3.35673 11.5577 3.25073 11.7657 3.25073 11.9984Z" fill="" />
              </svg>
              Cerrar sesión
            </button>
          </div>
        </div>
      }
    </div>
  </div>

  @if (isUserMenuOpen) {
    <div class="fixed inset-0 z-40" (click)="closeUserMenu()" aria-hidden="true"></div>
  }
</aside>
